import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../../../context/Context";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../../../component/form/form-layout";
import Style from "./style.module.css";


const AddLostDeal = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const validationSchema = yup.object({
    reason: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      reason: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        reason: values.reason,
      };

      console.log("values", data);

      try {
        const url = `deals/add-deal-lost-reason`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit) onSubmit(apiRes?.message || "Add Lost Deal successfully");
        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  return (
      <form onSubmit={formik.handleSubmit}>

         <LeftSidePopupLayout
                popupStatus={true}
                className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
              >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>Add Lost Deal</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>
        {/* Body */}
         <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
          <FormArea>
            {/* Team Name */}

            <FeildWraper width="100%">
              <FormLabel required>Reason</FormLabel>

              <input
                type="text"
                name="reason"
                value={formik.values.reason}
                onChange={formik.handleChange}
                placeholder="Reason"
              />
              {formik.touched.reason && formik.errors.reason && (
                <FeildError>{formik.errors.reason}</FeildError>
              )}
            </FeildWraper>
          </FormArea>
        </div>
        </div>
        </div>
        </div>

        {/* Footer */}
         <div className={`${Style.dcmb__cardFoot}`}>
                  <button
                    type="reset"
                    className={`${Style.dcmb__cancel}`}
                    onClick={onClose}
                  >
                    Discard
                  </button>
                  <button type="submit" className={Style.dcmb__submit}>
                    Apply
                  </button>
                </div>

        </LeftSidePopupLayout>
      </form>
  );
};

export default AddLostDeal;
